exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".update-mod .close-icon {\n  position: absolute;\n  right: 0;\n  top: 0;\n}", ""]);

// exports
